import React from "react";
import styles from "./styles.module.css";

export default function SmallCardKPI({ key, data }) {
  return (
    <div key={key} className="w-full mt-2">
      <h1 className="text-xl font-bold mb-4 ">{data.heading}</h1>
      <div
        className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 `}
      >
        {data.contents.length
          ? data.contents.map(({ Icon, label, count }, i) => (
              <div
                key={i}
                className={`${styles.kpiCard}  p-4  flex justify-center items-center flex-col gap-4`}
              >
                  <p className={styles.pIcon}>
                    <Icon />
                  </p>
                  <p className="font-bold text-lg">{count}</p>                
                  <p className="font-bold text-l">{label}</p>
              </div>
            ))
          : ""}
      </div>
    </div>
  );
}
